import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import AdminHeader from '../../components/header/AdminHeader';
import { useUserDetails } from '../../store/slices/authSlice';
import { userScriptGet } from '../../store/slices/callingSlice';
import { Col, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';

const CrmScript = () => {
  const user = useUserDetails();
  const { t } = useTranslation();
  const [scriptData, setScriptData] = useState(null);

  const dispatch = useDispatch();

  const getUserScript = async () => {
    try {
      const response = await dispatch(userScriptGet(user?.process_details?.script)).unwrap();
      setScriptData(response);
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    getUserScript();
  }, [user]);

  return (
    <div>
      <AdminHeader title={t('script')} />
      {scriptData ? (
        <Row className="py-5 px-3">
          {scriptData?.type === 'text' ? (
            <Col lg="12" className="fs-4">
              <div dangerouslySetInnerHTML={{ __html: scriptData?.type_option }} />
            </Col>
          ) : (
            <Col lg="12">
              <img
                src={scriptData?.type_option}
                alt="Script content"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  maxHeight: 'calc(100vh - 250px)'
                }}
              />
            </Col>
          )}
        </Row>
      ) : null}
    </div>
  );
};

export default CrmScript;
